import { render, staticRenderFns } from "./yhxy.vue?vue&type=template&id=476a9494"
import script from "./yhxy.vue?vue&type=script&lang=js"
export * from "./yhxy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports